import React from 'react'
import PropTypes from 'prop-types'

import EmergencyPhone from '@components/icons/emergency-phone.component'
import ArrowUp from '@components/icons/arrow-up.component'
import ArrowLeft from '@components/icons/arrow-left.component'
import ArrowDown from '@components/icons/arrow-down.component'
import CaretRight from '@components/icons/caret-right.component'
import Dot from '@components/icons/dot.component'
import Messages from '@components/icons/messages.component'
import Tips from '@components/icons/tips.component'
import Tree from '@components/icons/tree.component'
import Settings from '@components/icons/settings.component'
import Pin from '@components/icons/pin.component'
import PinSmall from '@components/icons/pin-small.component'
import Mask from '@components/icons/mask.component'
import Marker from '@components/icons/marker.component'
import Send from '@components/icons/send.component'
import Emergency from '@components/icons/emergency.component'
import Alert from '@components/icons/alert.component'
import Check from '@components/icons/check.component'
import Error from '@components/icons/error.component'
import Search from '@components/icons/search.component'
import Close from '@components/icons/close.component'
import Image from '@components/icons/resource-image.component'
import Link from '@components/icons/resource-link.component'
import Pdf from '@components/icons/resource-pdf.component'
import Phone from '@components/icons/resource-phone.component'
import Video from '@components/icons/resource-video.component'
import Document from '@components/icons/document.component'
import LogoPowered from '@components/icons/logo-powered.component'
import Shield from '@components/icons/shield.component'
import CirlcePlus from '@components/icons/circle-plus.component'

const Icon = ({ type, ...props }) => {
  switch (type) {
  case 'emergency-phone':
    return <EmergencyPhone {...props} />
  case 'dot':
    return <Dot {...props} />
  case 'arrow-up':
    return <ArrowUp {...props} />
  case 'arrow-left':
    return <ArrowLeft {...props} />
  case 'arrow-down':
    return <ArrowDown {...props} />
  case 'messages':
    return <Messages {...props} />
  case 'tips':
    return <Tips {...props} />
  case 'circle-plus':
    return <CirlcePlus {...props} />
  case 'resources':
  case 'document':
    return <Document {...props} />
  case 'shield':
    return <Shield {...props} />
  case 'settings':
    return <Settings {...props} />
  case 'pin':
    return <Pin {...props} />
  case 'pin-small':
    return <PinSmall {...props} />
  case 'mask':
    return <Mask {...props} />
  case 'send':
    return <Send {...props} />
  case 'check':
    return <Check {...props} />
  case 'emergency':
    return <Emergency {...props} />
  case 'error':
    return <Error {...props} />
  case 'search':
    return <Search {...props} />
  case 'close':
    return <Close {...props} />
  case 'caret-right':
    return <CaretRight {...props} />
  case 'video':
    return <Video {...props} />
  case 'phone':
    return <Phone {...props} />
  case 'image':
    return <Image {...props} />
  case 'pdf':
    return <Pdf {...props} />
  case 'tree':
    return <Tree {...props} />
  case 'link':
    return <Link {...props} />
  case 'alert':
    return <Alert {...props} />
  case 'logo-powered':
    return <LogoPowered {...props} />
  case 'marker':
    return <Marker {...props} />
  default:
    return null
  }
}

Icon.defaultProps = {
  strokeColor: '',
  style: {}
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  strokeColor: PropTypes.string,
  style: PropTypes.object
}

export default Icon
